import React from "react";
import { useTranslation } from 'react-i18next';
import { AddressPartEnum } from '../common/enums';
import { utils } from '../common/utils';

export default function (props) {
    const { t } = useTranslation();
    const { shipping, settings } = props;
    if (!shipping) return <div />;

    let addressLines = [], key = 0;

    settings.addressFormat.forEach(addressParts => {
        key++;
        var addressLine = addressParts.map(addressPart => {
            switch (addressPart) {
                case AddressPartEnum.Address1:
                    return shipping.address1;
                case AddressPartEnum.Address2:
                    return shipping.address2;
                case AddressPartEnum.Address3:
                    return shipping.address3;
                case AddressPartEnum.Address4:
                    return shipping.address4;
                case AddressPartEnum.PostCode:
                    return shipping.postCode;
                case AddressPartEnum.Region:
                    return shipping.regionName;
                case AddressPartEnum.Country:
                    return shipping.country;
                case AddressPartEnum.Organization:
                    return shipping.organization;
                default:
            }
        }).filter(addressPart => utils.isNullOrEmpty(addressPart) === false).join(', ');
        if (addressLine) {
            addressLines.push(<p key={key}>{addressLine}</p>);
        }
    });

    return (
        <div className="row padding-top-1x mt-3">
            <div className="col-sm-12">
                <h5>{t("Shipping to")}:</h5>
                <ul className="list-unstyled">
                    <li>
                        <span className="text-muted">{t("Client")}: </span>
                        {`${shipping.firstName} ${shipping.lastName}`}
                    </li>
                    <li>
                        <p className="text-muted">{t("ShippingAddress")}: </p>
                        {addressLines}
                    </li>
                </ul>
            </div>
        </div>
    );
}
